const PUBLIC_ROUTE_PATHS = ['/exam/public/answer'];
const PUBLIC_EXAM_ENTRY_PATH = PUBLIC_ROUTE_PATHS[0];
const PUBLIC_EXAM_HOSTNAME_LIST = PUBLIC_EXAM_HOSTS.split(',')
  .map((item) => item.trim())
  .filter(Boolean);

export const isPublicRoutePath = (pathname?: string) => {
  if (!pathname) {
    return false;
  }
  return PUBLIC_ROUTE_PATHS.some((path) => pathname.startsWith(path));
};

export const getPublicExamEntryPath = () => PUBLIC_EXAM_ENTRY_PATH;

export const isPublicExamHost = (hostname?: string) => {
  if (!hostname) {
    return false;
  }
  return PUBLIC_EXAM_HOSTNAME_LIST.includes(hostname);
};

export const shouldUsePublicExamOrigin = (
  pathname?: string,
  hostname?: string,
) => {
  if (!isPublicRoutePath(pathname)) {
    return false;
  }
  if (PUBLIC_EXAM_API_BASE_URL) {
    return false;
  }
  return isPublicExamHost(hostname);
};
